import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import HelpArticleLink from '../../../../../components/help-article-link';
import { linkIDs } from '../../../../../services/link-service/links';
import { AssistPanel } from '../assist-panel';
import { SyncActionButton } from './components/sync-action-button';
import { messages } from './messages';
import styles from './styles.module.less';

export const EnableInventorySyncPanel = () => {
  return (
    <AssistPanel header={<Text textType={TextType.H3} value={messages.checklistHeader} />} icon={faCircleCheck}>
      <span className={styles['step-title']}>
        <FormattedMessage {...messages.contentTitle} />
      </span>
      <Text className={styles['step-info']} textType={TextType.Paragraph} value={messages.contentInformation} />
      <FlexRow className={styles['step-button-panel']}>
        <SyncActionButton className={styles['move-to-marketplace-btn']} />
        <HelpArticleLink articleId={linkIDs.InventorySync} className={styles['learn-more-btn']}>
          <FormattedMessage {...messages.learnMore} />
          <FontAwesomeIcon icon={faAngleRight} />
        </HelpArticleLink>
      </FlexRow>
    </AssistPanel>
  );
};
